export default __webpack_public_path__ + "static/media/KOD0102-min.bd74645b.webp";